module.exports = __webpack_public_path__ + "img/banner2.d7ff3ffb.jpg";